import { messages as validation } from "vee-validate/dist/locale/en.json";

export default {
  "pl": {
    word: "{n} {word} | {n} {word}s",
  },
  "pl_no_number": {
    word: "{word} | {word}s",
  },
  "validation": {
    ...validation,
    credit_card: "The {_field_} field must be a valid credit card number",
    required_select: validation.required,
  },
  "notificationsText": {
    liked: "{screenName} liked your post",
    followed: "{screenName} followed you",
    subscribed: "{screenName} subscribed to you for {price}",
    upgradeSubscription: "{screenName} upgrade subscription to you. Now the subscription level is {price}",
    soldPost: "{screenName} bought your post for {price}",
    soldAttachment: "{screenName} bought your attach for {price}",
  },
  "Alabama": "Alabama",
  "Alaska": "Alaska",
  "American Samoa": "American Samoa",
  "Arizona": "Arizona",
  "Arkansas": "Arkansas",
  "California": "California",
  "Colorado": "Colorado",
  "Connecticut": "Connecticut",
  "Delaware": "Delaware",
  "District of Columbia": "District of Columbia",
  "Florida": "Florida",
  "Georgia": "Georgia",
  "Guam": "Guam",
  "Hawaii": "Hawaii",
  "Idaho": "Idaho",
  "Illinois": "Illinois",
  "Indiana": "Indiana",
  "Iowa": "Iowa",
  "Kansas": "Kansas",
  "Kentucky": "Kentucky",
  "Louisiana": "Louisiana",
  "Maine": "Maine",
  "Maryland": "Maryland",
  "Massachusetts": "Massachusetts",
  "Michigan": "Michigan",
  "Minnesota": "Minnesota",
  "Mississippi": "Mississippi",
  "Missouri": "Missouri",
  "Montana": "Montana",
  "Nebraska": "Nebraska",
  "Nevada": "Nevada",
  "New Hampshire": "New Hampshire",
  "New Jersey": "New Jersey",
  "New Mexico": "New Mexico",
  "New York": "New York",
  "North Carolina": "North Carolina",
  "North Dakota": "North Dakota",
  "Northern Mariana Islands": "Northern Mariana Islands",
  "Ohio": "Ohio",
  "Oklahoma": "Oklahoma",
  "Oregon": "Oregon",
  "Pennsylvania": "Pennsylvania",
  "Puerto Rico": "Puerto Rico",
  "Rhode Island": "Rhode Island",
  "South Carolina": "South Carolina",
  "South Dakota": "South Dakota",
  "Tennessee": "Tennessee",
  "Texas": "Texas",
  "U.S. Minor Outlying Islands": "U.S. Minor Outlying Islands",
  "U.S. Virgin Islands": "U.S. Virgin Islands",
  "Utah": "Utah",
  "Vermont": "Vermont",
  "Virginia": "Virginia",
  "Washington": "Washington",
  "West Virginia": "West Virginia",
  "Wisconsin": "Wisconsin",
  "Wyoming": "Wyoming",
  "There are no posts yet.": "There are no posts yet.",
  "Posts": "Posts",
  "Payout information": "Payout information",
  "Show": "Show",
  "Email": "Email",
  "Verification code": "Verification code",
  "follower": "follower",
  "subscriber": "subscriber",
  "user": "user",
  "This is the monthly subscription price for your page": "This is the monthly subscription price for your page",
  "Here are different monthly subscription levels for your page":
    "Here are different monthly subscription levels for your page",
  "Get a new code in {timer} seconds": "Get a new code in {timer} seconds",
  "Unlock for {price}": "Unlock for {price}",
  "Download{0}": "Download{0}",
  "Unlock{0}": "Unlock{0}",
  "Unfollow {0}?": "Unfollow {0}?",
  "{0} needs to agree to video chat.": "{0} needs to agree to video chat.",
  "{0} asks for video chat": "{0} asks for video chat",
  "{0} call": "{0} call",
  "Your {0}": "Your {0}",
  "Call for {0} per min": "Call for {0} per min",
  "Paid call{0}": "Paid call{0}",
  "from your {0}": "from your {0}",
  "The charge on your credit card bill will appear as {0} on your credit card statement":
    "The charge on your credit card bill will appear as {0} on your credit card statement",
  "loginPolicy":
    "By signing up, you confirm that you agree to our {termsOfUse} and have read and understood our {privacyPolicy}.",
  "Rebill from card **** {0} every month": "Rebill from card **** {0} every month",
  "Last rebill {0}": "Last rebill {0}",
  "Expires {0}": "Expires {0}",
  "Rebills {0}": "Rebills {0}",
  "Expired on {0}": "Expired on {0}",
  "Cancel rebill of {amount} subscription to {screenName}?": "Cancel rebill of {amount} subscription to {screenName}?",
  "Content will be available untill {0}.": "Content will be available untill {0}.",
  "{0} once": "{0} once",
  "{0}/mo": "{0}/mo",
  "preview_set_description": "Open some files {icon} so they can involve non-subscribers",
  "Cr": "$",
  "{0} Cr": "${0}",
  "{0} isn't following anyone yet": "{0} isn't following anyone yet",
  "{0} doesn't have followers yet": "{0} doesn't have followers yet",
  "sensitive_content_agreement": "I sign the sensitive content {sensitiveContentAgreement}",
  "{0} items": "{0} items",
  "Show all {0}": "Show all {0}",
  "{0} and higher": "{0} and higher",
  "netbillingTcAgree":
    "By submitting my information I certify that I am 18 years of age or older, have read and agree to the {termsOfUse}",
  "netbillingAddCardDescription": "Any charges will appear as “{companyName}” on your credit card statement.",
  "Scheduled for {0}": "Scheduled for {0}",
  "credit_card_explanation":
    "When you make a purchase on the platform, the funds are automatically debited from the card. You can change or remove your payment card at any time.",
  "Purchased for {0}": "Purchased for {0}",
  "Locked for {0}": "Locked for {0}",
  "{0} has sent you a message": "{0} has sent you a message",
  "securityReasonsInfoChange":
    "For security reasons, an administrator will need to approve your application for Creator status.",
  "Payee information": "Payee information",
  "Payee setup": "Payee setup",
  "profileEmptyTitle": "You are welcome!",
  "profileEmptyDescription": "Let's get started?",
  "Last visited {0}": "Last visited {0}",
  "Processing...": "Processing...",
  "{0} started live video": "{0} started live video",
  "Close": "Close",
  "Sign up": "Sign up",
  "Log in": "Log in",
  "it's better to have": "it's better to have",
  "1k paying fans than": "1k paying fans than",
  "100k passive ones": "100k passive ones",
  "Create and get paid": "Create and get paid",
  "You need sign up to continue": "You need sign up to continue",
  "Already have an account?": "Already have an account?",
  "Log in.": "Log in.",
  "Message": "Message",
  "Following": "Following",
  "Unfollow": "Unfollow",
  "Cancel": "Cancel",
  "DMCA": "DMCA",
  "Live": "Live",
  "Call ended": "Call ended",
  "Connecting...": "Connecting...",
  "Are you sure you want to close this window?": "Are you sure you want to close this window?",
  "Closing this dialog registration process will be stopped.":
    "Closing this dialog registration process will be stopped.",
  "You can always continue, just use login form.": "You can always continue, just use login form.",
  "No, continue registration": "No, continue registration",
  "Oops! It seems that there isn’t enough money on your balance.":
    "Oops! It seems that there isn’t enough money on your balance.",
  "Add money": "Add money",
  "PayPal": "PayPal",
  "PayPal email address": "PayPal email address",
  "Add files": "Add files",
  "or drag and drop files": "or drag and drop files",
  "Add cover": "Add cover",
  "Schedule post": "Schedule post",
  "New post": "New post",
  "Edit post": "Edit post",
  "Going live": "Going live",
  "Link to your live chat room:": "Link to your live chat room:",
  "Go live": "Go live",
  "Link copied": "Link copied",
  "Get the code": "Get the code",
  "Continue": "Continue",
  "Phone number": "Phone number",
  "Deleted post": "Deleted post",
  "Unlock": "Unlock",
  "{0} for {1}": "{0} for {1}",
  "Not purchased yet": "Not purchased yet",
  "Get access to this media": "Get access to this media",
  "Bio": "Bio",
  "Location": "Location",
  "Website": "Website",
  "Facebook": "Facebook",
  "Twitter": "Twitter",
  "Instagram": "Instagram",
  "TikTok": "TikTok",
  "YouTube": "YouTube",
  "Snapchat": "Snapchat",
  "Patreon": "Patreon",
  "OnlyFans": "OnlyFans",
  "Report": "Report",
  "Edit": "Edit",
  "Delete": "Delete",
  "Home": "Home",
  "Profile": "Profile",
  "Messages": "Messages",
  "Notifications": "Notifications",
  "More": "More",
  "Undo report": "Undo report",
  "This file is broken.": "This file is broken.",
  "It will not be displayed to the recipient.": "It will not be displayed to the recipient.",
  "Please wait.": "Please wait.",
  "Your file is uploading...": "Your file is uploading...",
  "This can take a few minutes.": "This can take a few minutes.",
  "Password": "Password",
  "Invalid verification code": "Invalid verification code",
  "Refund Policy": "Refund Policy",
  "Privacy Policy": "Privacy Policy",
  "Cookie Policy": "Cookie Policy",
  "Security Policy": "Security Policy",
  "18 U.S.C. 2257 Compliance": "18 U.S.C. 2257 Compliance",
  "Terms of Use": "Terms of Use",
  "Balance history": "Balance history",
  "+ Add money": "+ Add money",
  "Balance": "Balance",
  "Payout": "Payout",
  "E-mail notifications": "E-mail notifications",
  "Clear": "Clear",
  "Save": "Save",
  "Incoming messages": "Incoming messages",
  "Other": "Other",
  "Details": "Details",
  "Sign up with email": "Sign up with email",
  "Follow": "Follow",
  "Processing error": "Processing error",
  "Not published": "Not published",
  "Sensitive content": "Sensitive content",
  "Photo or scan of your ID": "Photo or scan of your ID",
  "Verify that you're over 18": "Verify that you're over 18",
  "We use your ID to verify your personal information. We do not publish or distribute your images.":
    "We use your ID to verify your personal information. We do not publish or distribute your images.",
  "Make sure that all information from the photo is easy to read.":
    "Make sure that all information from the photo is easy to read.",
  "Your photo with ID": "Your photo with ID",
  "First name": "First name",
  "Last name": "Last name",
  "Delete post?": "Delete post?",
  "This post will no longer be available for users who bought it.":
    "This post will no longer be available for users who bought it.",
  "Keep the post?": "Keep the post?",
  "Content will be saved and you can return to editing at any time.":
    "Content will be saved and you can return to editing at any time.",
  "Save draft": "Save draft",
  "Delete draft": "Delete draft",
  "Load more": "Load more",
  "Message price changed": "Message price changed",
  "Send message for {0}": "Send message for {0}",
  "Account settings": "Account settings",
  "Subscription management": "Subscription management",
  "Become Creator": "Become Creator",
  "Subscription levels": "Subscription levels",
  "Price settings": "Price settings",
  "Payment card": "Payment card",
  "Invite friends": "Invite friends",
  "Support": "Support",
  "Terms & Policies": "Terms & Policies",
  "Logout": "Logout",
  "Change password": "Change password",
  "Decline": "Decline",
  "First, what will your page be about?": "First, what will your page be about?",
  "Answer": "Answer",
  "Comment sent": "Comment sent",
  "Comment": "Comment",
  "Create Post": "Create Post",
  "Create post": "Create post",
  "Create event": "Create event",
  "Add Cover": "Add Cover",
  "Link to event": "Link to event",
  "Users will get access to this meeting link after the purchase":
    "Users will get access to this meeting link after the purchase",
  "Validating...": "Validating...",
  "The link field must be a valid url": "The link field must be a valid url",
  "Bank": "Bank",
  "Name on account": "Name on account",
  "Bank name": "Bank name",
  "Bank address": "Bank address",
  "Bank account number": "Bank account number",
  "Bank routing": "Bank routing",
  "Account details": "Account details",
  "Checking or savings account, etc.": "Checking or savings account, etc.",
  "Caption": "Caption",
  "Post now": "Post now",
  "Date": "Date",
  "Time": "Time",
  "Contact us": "Contact us",
  "Change card": "Change card",
  "Add": "Add",
  "Thank you for your purchase": "Thank you for your purchase",
  "Accessibility": "Accessibility",
  "Make it free": "Make it free",
  "Post is free now": "Post is free now",
  "Available for everyone": "Available for everyone",
  "Disable access by subscription": "Disable access by subscription",
  "Disable one-time buy": "Disable one-time buy",
  "Access for subscribers": "Access for subscribers",
  "One-time buy": "One-time buy",
  "hr": "hr",
  "min": "min",
  "Incoming": "Incoming",
  "Outgoing": "Outgoing",
  "sec": "sec",
  "User deleted": "User deleted",
  "Followers": "Followers",
  "You aren't following anyone yet": "You aren't following anyone yet",
  "You don't have followers yet": "You don't have followers yet",
  "Your account was successfully sent for verification": "Your account was successfully sent for verification",
  "We will email you when you are approved. For now, you can prepare content on your page. When verification and your application is approved, subscribers will be able to purchase it.":
    "We will email you when you are approved. For now, you can prepare content on your page. When verification and your application is approved, subscribers will be able to purchase it.",
  "Go to profile": "Go to profile",
  "Age": "Age",
  "Attached": "Attached",
  "Not attached": "Not attached",
  "Payout system": "Payout system",
  "Currency": "Currency",
  "Choose payout system": "Choose payout system",
  "Choose currency": "Choose currency",
  "Get access to this post": "Get access to this post",
  "Unlock for": "Unlock for",
  "or": "or",
  "Please click subscribe below": "Please click subscribe below",
  "The following subscription will give you access to this Creator's premium content":
    "The following subscription will give you access to this Creator's premium content",
  "Missed": "Missed",
  "Cancelled": "Cancelled",
  "Declined": "Declined",
  "Select previews": "Select previews",
  "Discover": "Discover",
  "This page may contain potentially sensitive content": "This page may contain potentially sensitive content",
  "Do you still want to view it?": "Do you still want to view it?",
  "Yes": "Yes",
  "No": "No",
  "You have previously saved draft.": "You have previously saved draft.",
  "Do you want to use it or delete and start from scratch?": "Do you want to use it or delete and start from scratch?",
  "Use draft": "Use draft",
  "From scratch": "From scratch",
  "Forgot password?": "Forgot password?",
  "Incorrect password or email": "Incorrect password or email",
  "Your balance": "Your balance",
  "Don’t show anymore": "Don’t show anymore",
  "We sent you a 6-digit code": "We sent you a 6-digit code",
  "Check your spam": "Check your spam",
  "Please enter the verification code we sent to {0}": "Please enter the verification code we sent to {0}",
  "Get a new code in {0} seconds": "Get a new code in {0} seconds",
  "Get a new code": "Get a new code",
  "Done": "Done",
  "You can unfollow only from the 'Following' menu. To cancel an active subscription level go to the 'Subscription management' menu.":
    "You can unfollow only from the 'Following' menu. To cancel an active subscription level go to the 'Subscription management' menu.",
  "By clicking the Follow button you will only get access to the creator's free content, to access additional content you can subscribe.":
    "By clicking the Follow button you will only get access to the creator's free content, to access additional content you can subscribe.",
  "Subscriptions": "Subscriptions",
  "Edit profile": "Edit profile",
  "Online": "Online",
  "Find someone to follow": "Find someone to follow",
  "Feed": "Feed",
  "Social media accounts": "Social media accounts",
  "Name": "Name",
  "Username": "Username",
  "Names can only contain letters, numbers, dashes, dots, and underscores.":
    "Names can only contain letters, numbers, dashes, dots, and underscores.",
  "You receive {0}% lifetime commission on all income earned by any user who joins the platform via your referral link.":
    "You receive {0}% lifetime commission on all income earned by any user who joins the platform via your referral link.",
  "1. Copy and share the link with the person who will make money on the platform":
    "1. Copy and share the link with the person who will make money on the platform",
  "2. Wait until that person signs up using your referral link":
    "2. Wait until that person signs up using your referral link",
  "3. Start getting {0}% from all income made by the person you invited":
    "3. Start getting {0}% from all income made by the person you invited",
  "Share link": "Share link",
  "Link copied to clipboard": "Link copied to clipboard",
  "Connection lost": "Connection lost",
  "Switching to video chat...": "Switching to video chat...",
  "Call ended due to connection error.": "Call ended due to connection error.",
  "Call back": "Call back",
  "Free": "Free",
  "Level": "Level",
  "Price": "Price",
  "You": "You",
  "Photo": "Photo",
  "Video": "Video",
  "Call": "Call",
  "Billing details": "Billing details",
  "Country": "Country",
  "Address": "Address",
  "City": "City",
  "State": "State",
  "Select state": "Select state",
  "Zip code": "Zip code",
  "This field is required": "This field is required",
  "Save this card for future purchases": "Save this card for future purchases",
  "This card will be used for subscription renewal and other purchases":
    "This card will be used for subscription renewal and other purchases",
  "Your data is safe.": "Your data is safe.",
  "Purchase": "Purchase",
  "Subscribe": "Subscribe",
  "Card details": "Card details",
  "Card Number": "Card Number",
  "Expiration Date": "Expiration Date",
  "CVV code": "CVV code",
  "Name on card": "Name on card",
  "Forgot password": "Forgot password",
  "Please enter your email address and we will send you instructions to reset password.":
    "Please enter your email address and we will send you instructions to reset password.",
  "Subscribers": "Subscribers",
  "All": "All",
  "Select:": "Select:",
  "Subscribers selected": "Subscribers selected",
  "Sign up & log in": "Sign up & log in",
  "We are real .": "We are real .",
  "We exist .": "We exist .",
  "Subscription": "Subscription",
  "per month": "per month",
  "Monetize each engagement with your subscribers through: ":
    "Monetize each engagement with your subscribers through: ",
  "monthly subscription": "monthly subscription",
  "paid posts": "paid posts",
  "text messages": "text messages",
  "private audio and video calls": "private audio and video calls",
  "Next": "Next",
  "Set password": "Set password",
  "Password field is empty": "Password field is empty",
  "Password has been changed": "Password has been changed",
  "Your data is secured.": "Your data is secured.",
  "Personal information": "Personal information",
  "Fill in your personal information to accept payments": "Fill in your personal information to accept payments",
  "Payment Card": "Payment Card",
  "Remove card": "Remove card",
  "Your payment card is successfully linked": "Your payment card is successfully linked",
  "No payment card to show": "No payment card to show",
  "Once you make your first purchase and save the card, it will appear on this page":
    "Once you make your first purchase and save the card, it will appear on this page",
  "Enable incoming calls": "Enable incoming calls",
  "Price per minute of call": "Price per minute of call",
  "Price per incoming message": "Price per incoming message",
  "Price per incoming media message": "Price per incoming media message",
  "Edit subscription level": "Edit subscription level",
  "All current members will be unsubscribed from paid access to your page.":
    "All current members will be unsubscribed from paid access to your page.",
  "Price for new subscribers. Сurrent subscribers will be unsubscribed at the end of the month":
    "Price for new subscribers. Сurrent subscribers will be unsubscribed at the end of the month",
  "No levels available": "No levels available",
  "You have not set up any paid subscriptions for your page":
    "You have not set up any paid subscriptions for your page",
  "Setup": "Setup",
  "Price per month": "Price per month",
  "Tell what kind of content your fans get buying this subscription level access":
    "Tell what kind of content your fans get buying this subscription level access",
  "It’s empty here.": "It’s empty here.",
  "Let’s find people to subscribe!": "Let’s find people to subscribe!",
  "Cancel rebill": "Cancel rebill",
  "Rebill canceled": "Rebill canceled",
  "Content will be available until {0}.": "Content will be available until {0}.",
  "End": "End",
  "Exit": "Exit",
  "We will inform your followers that you has started broadcasting":
    "We will inform your followers that you has started broadcasting",
  "Do you really want to end video live?": "Do you really want to end video live?",
  "End now": "End now",
  "Profile themes": "Profile themes",
  "Add subscription level": "Add subscription level",
  "Agree": "Agree",
  "Refuse": "Refuse",
  "Hide": "Hide",
  "New mass message": "New mass message",
  "Open link": "Open link",
  "link to event": "link to event",
  "or sign up with": "or sign up with",
  "Confirm email": "Confirm email",
  "To keep your data safe and protect the access to your account and password recovery please enter your email.":
    "To keep your data safe and protect the access to your account and password recovery please enter your email.",
  "Available": "Available",
  "We’re waiting for your payment": "We’re waiting for your payment",
  "Processing request...": "Processing request...",
  "1 min left! Please refill": "1 min left! Please refill",
  "Post": "Post",
  "Filter by themes": "Filter by themes",
  "Verification completed": "Verification completed",
  "Verification failed": "Verification failed",
  "Go to our site and enter the verification code from email we sent.":
    "Go to our site and enter the verification code from email we sent.",
  "Removing card": "Removing card",
  "Themes": "Themes",
  "Publish": "Publish",
  "Cost: free": "Cost: free",
  "Sign up or log in": "Sign up or log in",
  "or log in with": "or log in with",
  "more": "more",
  "Choose subscription": "Choose subscription",
  "per min": "per min",
  "Refund": "Refund",
  "Deposit": "Deposit",
  "Attachment": "Attachment",
  "Paid message": "Paid message",
  "Referral bonus": "Referral bonus",
  "Oops! Your feed is empty": "Oops! Your feed is empty",
  "Try to follow creators to build your own feed": "Try to follow creators to build your own feed",
  "Select recipients": "Select recipients",
  "recipient": "recipient",
  "Marked as important": "Marked as important",
  "Marked as common": "Marked as common",
  "This browser does not support WebRTC": "This browser does not support WebRTC",
  "Send for verification": "Send for verification",
  "agreement terms": "agreement terms",
  "And confirm that I am over 18": "And confirm that I am over 18",
  "Your paid posts become available to other users once your account is verified.":
    "Your paid posts become available to other users once your account is verified.",
  "Your referrals": "Your referrals",
  "new message": "new message",
  "page_complaints_annotation-1":
    "We are doing our best so you will enjoy the content provided. If, in any case, you have a complaint, please let us know.",
  "page_complaints_annotation-2": "All complaints will be reviewed and resolved within seven business days.",
  "internal_error_support": "Please refresh the page. If the problem persists contact {support}.",
  "Pending balance description":
    "Your balance will process on a 7 day rolling basis. For example. If a subscription, purchase, or tip is made on the 3rd of the month the earnings will become available for withdrawal on the 10th and so on.",
  "Statements": "Statements",
  "No earnings yet": "No earnings yet",
  "Attachments": "Attachments",
  "Tips": "Tips",
  "Earnings:": "Earnings:",
  "Net": "Net",
  "Gross": "Gross",
  "Fees:": "Fees:",
  "Platform fee": "Platform fee",
  "add_money_description":
    "The money added to the balance can be used to send a paid message, have a call with the creator or tip in messages, or live.",
  "user_upgrade_subscription_discount_description":
    "When upgrading your subscription, you will be charged now the difference between subscriptions. At the end of the 1 month subscription cycle, you will be charged the full subscription amount for all recurring months.",
  "for_the_first_month": "for the first month",
  "subscription_disabled_warning_line1": "Hello there",
  "subscription_disabled_warning_line2":
    "In order to create a more active and inspiring community, we're introducing a new policy.",
  "subscription_disabled_warning_line3":
    "You must upload content for the subscription level to appear. Please note that if no content is loaded within 30 days, the subscription level will disappear until content is loaded back to this subscription level. This is done to prevent chargebacks and refunds.",
  "subscription_disabled_warning_line4": "Let's work together to make our platform more engaging! 🚀📸",
  "automated_posts_no_files":
    'Auto posts for "{0}" have stopped due to insufficient files.  Please add more content to your folder to continue the auto posting feature.',
};
